import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './theme/tokens.css';

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root assente.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
